import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as endpoints from './endpoints';
import {
  addCompensation,
  addCompensationSuccess,
  addCompensationFailed,
  addOfferLetter,
  addOfferLetterFailed,
  addOfferLetterSuccess,
} from './slice';
import { request } from '@app/services';

function* addCompensationSaga(action: ReturnType<typeof addCompensation>): any {
  try {
    const { name, date, revisedSalary, monthlySalary, quarterlyAllowance } = action.payload;
    const result = yield call(request.post, endpoints.addCompensation, {
      name,
      date,
      revisedSalary,
      monthlySalary,
      quarterlyAllowance,
    });
    yield put(addCompensationSuccess(result.data));
  } catch (err) {
    yield put(addCompensationFailed(err));
  }
}
//
function* addOfferLetterSaga(action: ReturnType<typeof addOfferLetter>): any {
  try {
    const { fullName, joiningDate, address, position, monthlySalary, contraction } = action.payload;
    const result = yield call(request.post, endpoints.addOfferLetter, {
      name: fullName,
      date: joiningDate,
      address,
      position,
      salary: monthlySalary,
      contraction,
    });
    yield put(addOfferLetterSuccess(result.data));
  } catch (err) {
    yield put(addOfferLetterFailed(err));
  }
}

function* documentsSagas() {
  yield all([
    takeLatest(addCompensation, addCompensationSaga),
    takeLatest(addOfferLetter, addOfferLetterSaga),
  ]);
}

export { documentsSagas };
